import { configFetch as fetch } from '@laigu/utils';

export const addSubSourceApi = (source, display_name) => {
  return fetch({
    url: '/unified-api/team/v1/agent/enterprise_config/sub_source',
    method: 'post',
    data: {
      source,
      display_name
    }
  });
};

export const deleteSubSourceApi = (source, { sub_source_name }) => {
  return fetch({
    url: '/unified-api/team/v1/agent/enterprise_config/sub_source',
    method: 'delete',
    data: {
      source,
      sub_source_name
    }
  });
};

export const getSubSourceApi = source => {
  return fetch({
    url: `/v1/ent_config/sources/${source}/sub_sources`,
    method: 'get'
  });
};

export const updateSubSourceApi = (source, data) => {
  return fetch({
    url: `/v1/ent_config/sources/${source}/sub_sources/${data.sub_source_name}`,
    method: 'put',
    data
  });
};
